import Grid from '@material-ui/core/Grid';
import GridFormField from 'shared/components/GridFormField';
import React from 'react';
import removeHTML from 'shared/utils/removeHTML';
import {
	dateInRange,
	isAfterDobCoApp,
	maxStrLength,
	numericValidation,
	phoneNumberValidation,
	settingValidation,
} from 'shared/utils/validations';
import Typography from '@material-ui/core/Typography';
import { formatNumber, formatPhone, parseNumber, parsePhone } from 'shared/utils/formatting';
import { FormSection } from 'redux-form';
import { PropTypes } from 'prop-types';
import {
	COAPP_CURRENT_RESIDENCE,
	DATE_RANGE_START_YEAR,
	DATE_RANGE_START_MONTH,
	DATE_RANGE_START_DAY,
} from './constants';

const CoAppCurrentResidenceFields = ({ disableAll, settings, name }) => (
	<FormSection name={name} style={{ width: '100%' }}>
		<Grid container spacing={5}>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppHousingIndicatorLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppHousingIndicatorDescription}
				fieldSettings={settings.coApp.housingOwnOrRent}
				name="housingIndicator"
				select
				menuOptions={settings.comboFields.COAPPHOUSING}
				validation={settingValidation(settings.coApp.housingOwnOrRent)}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppHomePhoneLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppHomePhoneDescription}
				fieldSettings={settings.coApp.homePhone}
				name="homePhone"
				validation={[settingValidation(settings.coApp.homePhone), phoneNumberValidation('US')]}
				disabled={disableAll}
				format={formatPhone('US')}
				parse={parsePhone('US')}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppCellPhoneLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppCellPhoneDescription}
				fieldSettings={settings.coApp.cellPhone}
				name="cellPhone"
				validation={[settingValidation(settings.coApp.cellPhone), phoneNumberValidation('US')]}
				disabled={disableAll}
				format={formatPhone('US')}
				parse={parsePhone('US')}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppResidenceStartLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppResidenceStartDescription}
				fieldSettings={settings.coApp.housingTimeAtResidence}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' }, 
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="currentAddressTermStart"
				validation={[
					settingValidation(settings.coApp.housingTimeAtResidence),
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isAfterDobCoApp,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppMonthlyPaymentLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppMonthlyPaymentDescription}
				fieldSettings={settings.coApp.housingMonthlyPayment}
				name="monthlyRent"
				validation={[
					settingValidation(settings.coApp.housingMonthlyPayment),
					maxStrLength(5),
					numericValidation,
				]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
		</Grid>
		<Typography type="caption" component="div" style={{ paddingTop: '20px' }}>
			<div
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: removeHTML(settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppCurrentResidenceFooter),
				}}
			/>
		</Typography>
	</FormSection>
);

CoAppCurrentResidenceFields.propTypes = {
	disableAll: PropTypes.bool,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
	}),
	name: PropTypes.string,
};

CoAppCurrentResidenceFields.defaultProps = {
	disableAll: false,
	settings: {},
	name: COAPP_CURRENT_RESIDENCE,
};

export default CoAppCurrentResidenceFields;
